import { BaseModule } from "./base.module";
import { BootstrapFormValidationModule } from './bootstrap-form-validation.module';
import * as bootstrap from 'bootstrap';

export class ExhibitorOverviewModule extends BaseModule {
    collapseElementsSelector = '.exhibitor-item-collapse';
    exhibitorsDetailsColumnSelector = '.exhibitors-details-column';
    exhibitorsDetailsColumn = null;
    exhibitorItemsColumnSelector = '.exhibitor-items-column';
    exhibitorItemsColumn = null;
    exhibitorsContainerClassSelector = 'exhibitors-container';
    exhibitorsContainerOverviewStateClassSelector = 'exhibitors-container-overview-state';
    exhibitorsContainerDetailStateClassSelector = 'exhibitors-container-detail-state';
    navbarHeight = null;
    collapseElementShowHandlers = [];
    collapseElementShownHandlers = [];
    exhibitorsContainer = document.querySelector(`.${this.exhibitorsContainerClassSelector}`);
    extraTopOffset = 20;
    initialize() {
        this.exhibitorsDetailsColumn = document.querySelector(this.exhibitorsDetailsColumnSelector);
        this.exhibitorItemsColumn = document.querySelector(this.exhibitorItemsColumnSelector);
        this.setupInitialTopOffset();
        this.setEventListeners();
    }

    setupInitialTopOffset() {
        let element = document.querySelector(`.${this.exhibitorsContainerClassSelector}`);
        this.setupTopOffsetByElement(element);
    }

    setupTopOffsetByElement(element) {
        if (element) {
            this.offsetTop = element.getBoundingClientRect().top + window.scrollY;
            console.log('setupTopOffsetByElement', this.offsetTop);
        }
    }

    setEventListeners() {
        this.setDocumentObjectModelContentLoadedEventListener();
        this.setCollapsiblesEventListeners();
        this.setBootstrapNavigationBarHeightEventListeners();
    }

    /**
     * 
     * @param {*} event 
    */
    handleBootstrapNavigationBarHeight(event) {
        if (event.data) {
            let height = event.data;
        }
        if (this.exhibitorsContainer) {
            this.offsetTop = this.exhibitorsContainer.getBoundingClientRect().top + window.scrollY;
        }
    }

    createCollapsibleEventListeners() {
        if (this.exhibitorItemsColumn) {
            let collapseElementsResult = this.exhibitorItemsColumn.querySelectorAll(`${this.collapseElementsSelector}`);
            this.collapseElements = Array.from(collapseElementsResult);
            this.collapseElements.forEach((collapseElement) => {
                collapseElement.addEventListener('show.bs.collapse', this);
                collapseElement.addEventListener('shown.bs.collapse', this);
            });
        }

    }

    setCollapsiblesEventListeners() {
        this.createCollapsibleEventListeners();
        document.addEventListener('nexus.load.exhibitors', () => {
            this.createCollapsibleEventListeners();
        });

        document.addEventListener('click', (event) => {
            let target = event.target.closest('.exhibitors-container [data-bs-target]');
            if (target) {
                this.createCollapsibleEventListeners();
            }
        });
    }

    /**
     * 
     * @param {Event} event 
     */
    handleEvent(event) {
        switch (event.type) {
            case 'show.bs.collapse':
                this.handleCollapseShow(event);
                break;
            case 'shown.bs.collapse':
                this.handleCollapseShown(event);
                break;

            default:
                break;
        }
    }

    getBreakPoint() {
        let bodyStyle = getComputedStyle(document.querySelector('body'));
        if (bodyStyle) {
            let breakPoint = bodyStyle.getPropertyValue('--current-breakpoint');
            return breakPoint;
        }
    }

    screenIsExtraLarge(breakPoint) {
        switch (breakPoint) {
            case 'xl':
            case 'xxl':
                return true;
            default:
                return false;
        }
    }

    /**
     * 
     * @param {Event} event 
     */
    handleCollapseShow(event) {
        let exhibitorDetailColumnOriginal = event.target.querySelector('.exhibitor-detail-column');
        // console.log('exhibitorDetailColumnOriginal', exhibitorDetailColumnOriginal);
        if (exhibitorDetailColumnOriginal) {
            let exhibitorDetailColumnCopy = event.target.closest(`.${this.exhibitorsContainerClassSelector}`).querySelector('.exhibitors-details-column');
            if (exhibitorDetailColumnCopy) {
                // console.log('exhibitorDetailColumnCopy', exhibitorDetailColumnCopy);
                exhibitorDetailColumnCopy.innerHTML = exhibitorDetailColumnOriginal.innerHTML;
                let formValidationModule = new BootstrapFormValidationModule();
                formValidationModule.initialize(exhibitorDetailColumnCopy);
            }
        }
        console.log('handleCollapseShow', event, event.target);
        let closeIconButtons = event.target.closest(`.${this.exhibitorsContainerClassSelector}`).querySelectorAll('.exhibitors-details-column .close-button');
        closeIconButtons.forEach((closeIconButton) => {
            closeIconButton.addEventListener('click', (event) => {
                event.preventDefault();
                console.log('closeIconButton.dataset', closeIconButton.dataset);
                if (closeIconButton.dataset && closeIconButton.dataset.overviewItemTrigger) {
                    let overviewItemTrigger = document.querySelector(`[data-bs-target="${closeIconButton.dataset.overviewItemTrigger}"]`);
                    console.log('overviewItemTrigger closeIconButton', overviewItemTrigger);
                    overviewItemTrigger.focus();
                }
                let instance = bootstrap.Collapse.getOrCreateInstance(event.target);
                instance.hide();
                let closestExhibitorsContainer = event.target.closest(`.${this.exhibitorsContainerClassSelector}`);
                closestExhibitorsContainer.classList.add(this.exhibitorsContainerOverviewStateClassSelector);
                closestExhibitorsContainer.classList.remove(this.exhibitorsContainerDetailStateClassSelector);
            });
        });

        let nextItemButtons = event.target.closest(`.${this.exhibitorsContainerClassSelector}`).querySelectorAll('.exhibitors-details-column .next-exhibitor-item');
        if (nextItemButtons) {
            nextItemButtons.forEach((nextItemButton) => {
                console.log('nextItemButton', nextItemButton);
                nextItemButton.addEventListener('click', () => {
                    let overviewItemTrigger = document.querySelector(`[data-bs-target="${nextItemButton.dataset.overviewItemTrigger}"]`);
                    console.log('overviewItemTrigger nextItemButton', overviewItemTrigger);
                    overviewItemTrigger.focus();
                });
            });
        }
    }

    /**
     * 
     * @param {Event} event 
     */
    handleCollapseShown(event) {
        if (this.screenIsExtraLarge(this.getBreakPoint()) === true) {
            let exhibitorDetailColumnOriginal = event.target.querySelector('.exhibitor-detail-column');
            // console.log('exhibitorDetailColumnOriginal', exhibitorDetailColumnOriginal);
            if (exhibitorDetailColumnOriginal) {
                let exhibitorDetailColumnCopy = event.target.closest(`.${this.exhibitorsContainerClassSelector}`).querySelector('.exhibitors-details-column');
                if (exhibitorDetailColumnCopy) {
                    // console.log('exhibitorDetailColumnCopy', exhibitorDetailColumnCopy);
                    console.log('offsetTop', this.offsetTop);
                    // this.setupTopOffsetByElement(exhibitorDetailColumnCopy);
                    let subtracted = this.offsetTop - parseInt(document.documentElement.style.getPropertyValue(`--nexus-navigation-bar-height-in-pixels`)) - this.extraTopOffset;
                    console.log('subtracted scroll', subtracted);
                    setTimeout(() => {
                        window.scroll({
                            top: subtracted,
                            behavior: 'smooth',
                        });
                    }, 1);
                }
            }
        }

        let closestExhibitorsContainer = event.target.closest(`.${this.exhibitorsContainerClassSelector}`);
        closestExhibitorsContainer.classList.add(this.exhibitorsContainerDetailStateClassSelector);
        closestExhibitorsContainer.classList.remove(this.exhibitorsContainerOverviewStateClassSelector);
        let exhibitorDetailColumnCopy = event.target.closest(`.${this.exhibitorsContainerClassSelector}`).querySelector('.exhibitors-details-column');
        exhibitorDetailColumnCopy.classList.remove('invisible');

        let exhibitorItemColumn = event.target.closest('.exhibitor-item-column');

        if (this.exhibitorItemsColumn && exhibitorItemColumn) {
            if (exhibitorItemColumn.offsetTop > 0) {
                this.exhibitorItemsColumn.scroll({
                    top: exhibitorItemColumn.offsetTop,
                    behavior: 'smooth',
                });
            } else {
                console.warn('exhibitorItemColumn offsetTop is not above 0');
            }
        }

        if (this.screenIsExtraLarge(this.getBreakPoint()) === true) {
            exhibitorDetailColumnCopy.focus(); // force focus on the detail item
        }

    }

    setBootstrapNavigationBarHeightEventListeners() {
        this.handleBootstrapNavigationBarHeight.bind(this);
        window.addEventListener('load', () => {
            document.addEventListener(
                'navigation-bar-height',
                (event) => {
                    this.handleBootstrapNavigationBarHeight(event);
                }
            );
        });
    }

    setDocumentObjectModelContentLoadedEventListener() {
        document.addEventListener('DOMContentLoaded', () => {
            $('body').on('click', '.exhibitor-link', (event) => {
                event.preventDefault();
            });

            // contact form
            document.addEventListener('click', (event) => {
                let button = event.target.closest('.exhibitor-contact-form-container button[type="submit"]');
                if (button) {
                    let form = button.closest('form');
                    var data = {
                        action: 'contact_exhibitor',
                        security: wp_ajax.ajaxnonce,
                        data: $(button.closest('form')).serialize(),
                    };
                    $.post(
                        wp_ajax.ajaxurl,
                        data,
                        function (response) {
                            if (form) {
                                if (form.parentElement) {
                                    let responseElement = form.parentElement.querySelector('.contact-exhibitor-response');
                                    if (response.success === true) {
                                        if (responseElement) {
                                            responseElement.textContent = response.data;
                                            responseElement.classList.remove('bg-info');
                                            responseElement.classList.add('bg-success');
                                        }
                                    } else {
                                        if (response && typeof response.data !== 'undefined' && typeof response.data.error !== 'undefined') {
                                            responseElement.html(response.data.error);
                                            responseElement.classList.remove('bg-info');
                                            responseElement.classList.add('bg-danger');
                                        }
                                    }
                                }
                            }
                        }
                    );
                }
            });

            // default enter
            $('#jb-content-filters').on('submit', (event) => {
                event.preventDefault();
                this.build_filter_history($('#jb-content-textfield').get(0));
                $("#jb-content-textfield").val('');
                this.search_exhibitors();
            });

            // the selects
            $('.exhibitor-select-filter').on('change', (event) => {
                event.preventDefault();
                this.build_filter_history(event.currentTarget);
                // reset to default
                $(".exhibitor-select-filter").val('');
                this.search_exhibitors();
            });

            // remove filter button
            $('body').on('click', '.selected-filter-btn', (event) => {
                event.preventDefault();
                $(event.currentTarget).remove();
                this.search_exhibitors();
            });


            // detail filters

            $('body').on('click', '.exhibitor-detail-filter', (event) => {
                console.log('detail filters', event);
                event.preventDefault();
                let id = $(event.currentTarget).data("id");
                let key = $(event.currentTarget).data("key");
                $('select[name=' + key + ']').val(id).change();
            });


            // pager
            $('body').on('click', '.exhibitor-pager .page-link', (event) => {

                event.preventDefault();
                var page = 1;
                if ($(event.currentTarget).attr("href")) {

                    // initial page load
                    var paged_url = $(event.currentTarget).attr("href");
                    const paged_arr = paged_url.split('/');
                    page = parseInt(paged_arr[paged_arr.length - 1]);

                    // ajax-built pager
                    let paramString = paged_url.split('?')[1];
                    let queryString = new URLSearchParams(paramString);
                    if (queryString.has('paged')) {
                        page = queryString.get('paged');
                    }

                }
                this.reset_view_state();
                this.search_exhibitors(page);

            });


        });
    }

    build_filter_history(this_input) {
        if (!$('#filter-' + this_input.value).length) {
            let button_title = '';
            if (this_input.type == 'select-one') {
                button_title = this_input.options[this_input.selectedIndex].text;
            }
            if (this_input.type == 'text') {
                button_title = this_input.value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            }
            var button = '<a href="#" class="selected-filter-btn element-link gy-2" id="filter-' + encodeURIComponent(this_input.value) + '">' +
                '   <div class="d-inline-block badge badge-inline rounded-pill text-bg-tertiary text-gray-100 p-2 mb-1">' +
                '   <input type="hidden" name="' + encodeURIComponent(this_input.name) + '[]" value="' + encodeURIComponent(this_input.value) + '" class="exhibitor-filter">' +
                '       <span slot="text">' +
                '           <span class="hyphenate">' + button_title + '</span>' +
                '       </span>' +
                '       <svg class="align-self-center badge-icon icon-15 ">' +
                '           <title>Sluit icoon</title>' +
                '           <use xlink:href="#icon-close"></use>' +
                '       </svg>' +
                '    </div>' +
                '</a>';
            $('#filter-history').append(button);
        }
    }

    reset_view_state() {
        $(".exhibitors-container").removeClass('exhibitors-container-detail-state').addClass('exhibitors-container-overview-state');
    }

    search_exhibitors(page = 0) {

        this.reset_view_state();

        var data = {
            action: 'search_exhibitors',
            security: wp_ajax.ajaxnonce,
            tax_and_search_filter: $('#jb-content-filters .exhibitor-filter').serialize(),
            paged: page,
            items_per_page: $('#jb-content-filters input[name=items-pp]').val()
        };

        $.post(
            wp_ajax.ajaxurl,
            data,
            (response) => {
                // console.log(response);
                if (!response.success) {
                    // No data came back, maybe a security error
                    if (!response.data) {
                        $('#jexhibitor-accordion').html('AJAX ERROR: no response');
                    } else {
                        $('#jb-err-message').html(response.data.error);
                    }
                } else if (response.data) {
                    $('#jb-err-message').html('');
                    $('#exhibitor-accordion').html(response.data.listing);
                    $('#exhibitor-pager').html(response.data.pager);

                    this.triggerEventOnElement('nexus.load.exhibitors', document)

                    $('#jb-content-detail-wrapper').html('');

                } else {
                    $('#jb-err-message').html('');
                }

            }
        );
    }

}